var render, staticRenderFns
import script from "./Botbar.vue?vue&type=script&lang=js&"
export * from "./Botbar.vue?vue&type=script&lang=js&"
import style0 from "./Botbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wolf/Documents/Apps/Trading/trading-vue-bundle/trading-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9030b5c8')) {
      api.createRecord('9030b5c8', component.options)
    } else {
      api.reload('9030b5c8', component.options)
    }
    
  }
}
component.options.__file = "src/components/Botbar.vue"
export default component.exports